import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { DynamicFormComponent } from 'core/components/forms/dynamic-form.component';
import { Group } from 'core/models/group';
import { ActivatedRoute } from '@angular/router';
import { GroupsService } from 'core/services/groups.service';
import { UtilsService } from 'core/services/utils.service';
import { MarsGroupConfigRankingQuestionsService } from './mars-group-config-ranking-questions.service';
import { MarsGroupConfigDocumentationQuestionsService } from './mars-group-config-documentation-questions.service';
import { Game } from 'core/models/game';

@Component({
  selector: 'lms-mars-group-config',
  templateUrl: './mars-group-config.component.html',
  styleUrls: ['./mars-group-config.component.scss'],
  providers: [MarsGroupConfigDocumentationQuestionsService, MarsGroupConfigRankingQuestionsService]
})
export class MarsGroupConfigComponent implements OnInit {
  @Input() group: Group;
  @Input() game: Game;
  @Input() data: any = {};
  @Output() save = new EventEmitter<Group>();
  @ViewChild('administratorsForm', { static: false })
  public administratorsForm: DynamicFormComponent;
  @ViewChild('rankingForm', { static: false }) public rankingForm: DynamicFormComponent;
  @ViewChild('documentationForm', { static: false }) public documentationForm: DynamicFormComponent;

  constructor(
    public route: ActivatedRoute,
    public groupsService: GroupsService,
    public documentationQuestionsService: MarsGroupConfigDocumentationQuestionsService,
    public rankingQuestionsService: MarsGroupConfigRankingQuestionsService
  ) {}

  ngOnInit() {
    this.route.data.subscribe((data) => {
      if (data.questionsDataScheme) {
        this.data = UtilsService.getQuestionsData(this.route.snapshot, data.questionsDataScheme);
      }
    });
  }

  updateAdministrators(administrators) {
    const updatedGroup: Group = Object.assign({}, this.group, administrators);
    this.groupsService
      .update(updatedGroup)
      .then((group) => {
        this.save.emit(group);
        this.administratorsForm.submitted(null);
      })
      .catch((err) => {
        this.administratorsForm.submitted(err);
      });
  }

  updateRanking({ rankingConfig }) {
    const updatedGroup: Group = Object.assign({}, this.group);
    updatedGroup.flags.showRanking = rankingConfig === 'showRanking';
    updatedGroup.flags.showAlias = rankingConfig === 'showAlias';
    updatedGroup.flags.obfuscateRanking = rankingConfig === 'obfuscateRanking';
    this.groupsService
      .update(updatedGroup)
      .then((group) => {
        this.save.emit(group);
        this.rankingForm.submitted(null);
      })
      .catch((err) => {
        this.rankingForm.submitted(err);
      });
  }

  updateDocumentation(documentation) {
    const updatedGroup: Group = Object.assign({}, this.group, { documentation });
    this.groupsService
      .update(updatedGroup)
      .then((group) => {
        this.save.emit(group);
        this.documentationForm.submitted(null);
      })
      .catch((err) => {
        this.documentationForm.submitted(err);
      });
  }
}
